module.exports = __webpack_public_path__ + "static/media/csv.d1e05f1e.png";